/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

jQuery(function ($) {
  /**
   * Product Page
   */
  $('.js-product-read-more').on('click', function (e) {
    e.preventDefault();

    $([document.documentElement, document.body]).animate({
      scrollTop: $('.js-product-description').offset().top - $('.Header__Wrapper').outerHeight(),
    }, 1500);
  });


  /**
   * Page side nav
   */
  $('.page-columns__side ul a').on('click', function (e) {
    e.preventDefault();
    var section = $(this).attr('href');
    console.log(section);

    $([document.documentElement, document.body]).animate({
      scrollTop: $(section).offset().top - $('.Header__Wrapper').outerHeight(),
    }, 1500);
  });

  /**
   * Shipping Urgency
   */
  $('.js-shipping-urgency').each(function () {
    var $wrap = $(this);
    var cutoff = $wrap.data('cutoff');
    var timezone = $wrap.data('timezone');
    var message = $wrap.data('message');

    var currentTime = moment().tz(timezone);
    var cutoffTime = currentTime.clone().hour(cutoff).minute(0).second(0);

    if (currentTime.isBefore(cutoffTime)) {
      var hoursLeft = cutoffTime.diff(currentTime, 'hours');
      var minutesLeft = cutoffTime.diff(currentTime, 'minutes');
      var clearMinutes = minutesLeft % 60;

      var countdownTime = hoursLeft + 'h ' + clearMinutes + 'm';
      var formatedMeassage = message.replace('{countdown}', countdownTime);
    
      $wrap.find('.js-shipping-urgency-label').html(formatedMeassage)

      $wrap.addClass('visible');
    }
  });


  /**
   * Product confirmation acitons
   */

  $('.js-product-confirm-bg, .js-product-confirm-close').on('click', function(e) {
    e.preventDefault();
    $('.js-product-confirm').removeClass('open');
  });


  /**
   * Add to cart
   */
  var updateCartCount = function(newQuantity) {
    var $cartCounter = $('.js-cart-counter');
    var currentCount = +$cartCounter.text();
    var newCount = currentCount + newQuantity;
    $cartCounter.text(newCount);
  };

  var showProductConfirm = function(data) {
    var $confirmBox = $('.js-product-confirm');
    $confirmBox.find('.js-confirm-title').text(data.product_title);
    $confirmBox.find('.js-confirm-variant').text(data.variant_title);
    $confirmBox.find('.js-confirm-image').attr('src', data.image);
    $confirmBox.addClass('open');
  };

  var toggleCartLoading = function(show) {
    var loadingClass = 'loading';
    var $addtocartBtnWrap = $('.js-product-addtocart-wrap');

    if (show) {
      $addtocartBtnWrap.addClass(loadingClass);
    } else {
      $addtocartBtnWrap.removeClass(loadingClass);
    }
  }

  $('.ProductForm__AddToCartWrap').on('click', '.ProductForm__AddToCart', function(e) {
    e.preventDefault();

    var productId = $('.js-product-id').val();
    var productQty = +$('.js-product-qty').val();

    toggleCartLoading(true);

    // Add To Cart API Call
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: productQty,
        id: productId
      },
      dataType: 'json',
      success: function(data) {
        updateCartCount(productQty);
        showProductConfirm(data);
        toggleCartLoading(false);
      },
      error: function(error, textStatus) {
        console.log(error);
        console.log(textStatus);
        toggleCartLoading(false);
      }
    };

    $.ajax(params);
  });


  /**
   * Swim to top
   */
  var $backToTopButton = $('.js-back-to-top');

  $(window).scroll(function() {
    if ($(document).scrollTop() > 300) {
      $backToTopButton.addClass('visible');
    }
    else {
      $backToTopButton.removeClass('visible');
    }
  });

  $backToTopButton.on('click', function(e) {
    $([document.documentElement, document.body]).animate({
      scrollTop: 0,
    }, 500);
  });


  /**
   * Color Filters
   */
  $('.js-show-more-color-filters').on('click', function(e) {
    e.preventDefault();
    $('.ColorSwatchItem--hidden').removeClass('ColorSwatchItem--hidden');
    $(this).hide();
  });


  /**
   * Product item slider
   */
  $('.ProductItemSlider').slick({
    lazyLoad: 'ondemand',
  });


  /**
   * Size Guide
   */
  var $sizeGuide = $('.js-size-guide-modal');
  if ($sizeGuide.length) {
    var intro = $sizeGuide.data('intro');
    var table = $sizeGuide.data('table');
    var tips = $sizeGuide.data('tips') ? $sizeGuide.data('tips').split(',') : [];
    var img = $sizeGuide.data('img');

    if (intro) {
      $sizeGuide.find('.js-size-guide-intro.' + intro).show();
    }

    if (table) {
      $sizeGuide.find('.js-size-guide-table.' + table).show();
    }

    if (img) {
      var $img = $sizeGuide.find('.js-size-guide-img.' + img);
      $img.attr('src', $img.data('src')).show();
    }

    tips.forEach(function(item) {
      $sizeGuide.find('.js-size-guide-tip.' + item).show();
    });
  }


  /**
   * Search color switches
   */
  if ($('body').hasClass('template-search')) {
    var productList = document.querySelector('.ProductList');
    new window.ProductItemColorSwatch(productList);
  }


  /**
   * Navigation position fix
   */
  $('.Header__MainNav .DropdownMenu').each(function() {
    var dropdown = $(this);
    var position = dropdown.position();
    var width = dropdown.outerWidth();
    var endPosition = position.left + width;

    if (endPosition > window.outerWidth) {
      dropdown.css({right:0});
    }    
  });
   


  /**
   * Reorder size filters
   */
  var sizeOrder = ['xs', 's', 's-m', 'm', 'l', 'l-xl', 'xl', '2xl', '2xl-3xl', '3xl', '4xl', 'plus', 'regular', 'os'];
  sizeOrder.reverse().forEach(function(size) {
    $('[data-tag="size_' + size + '"]').each(function() {
      var sizeItem = $(this).parent();
      var sizeList = sizeItem.parent();
      sizeList.prepend(sizeItem);
    });
  });


  /**
   * Footer Mobile Tabs
   */
  $('.Footer .Footer__Title').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('open');
  });


  /**
   * Color specific images on product page
   */
  if ($('body').hasClass('template-product')) {
    var productColorSwatch = $('.ProductForm__Variants .ColorSwatch__Radio');
    var slideshowCells;
    var slideshowThumbnails;

    // Toggle visible images
    var showOnlyColorImages = function(color) {
      // Desktop thumbnails
      $('.Product__SlideshowNav .Product__SlideshowNavImage').each(function() {
        var navImage = $(this);
        var imageColor = navImage.data('image-color');

        if (imageColor === color) {
          navImage.show();
        } else {
          navImage.hide();
        }
      });

      // Mobile slideshow
      var visibleSlideshowCells = slideshowCells.filter(function(cell) {
        return cell.dataset.imageColor === color;
      });

      var slideshow = window.productSlideshow.flickityInstance;
      slideshow.remove(slideshowCells);
      slideshow.append(visibleSlideshowCells);
      slideshow.select(0, true, true);
    };

    // Handle color change
    productColorSwatch.on('change', function(e) {
      e.preventDefault();
      var selectedColor = $(this).data('color');
      showOnlyColorImages(selectedColor);    
    });

    
    // Get elements
    if (window.productSlideshow) {
      slideshowCells = window.productSlideshow.flickityInstance.getCellElements();
    }

    // Initial color switch
    if (productColorSwatch.length) {
      var initialColor = productColorSwatch.filter(':checked').data('color');
      showOnlyColorImages(initialColor);
    }
  }
});



/**
 * Personalized tracking
 */
jQuery(function($) {
  if (!$('body').hasClass('template-product')) return;
  if (!localStorage) return;

  var STORAGE_KEY = 'pxt_collection_engagement';
  var productBreadcrumbs = $('.Breadcrumbs');  

  if (productBreadcrumbs.length > 0) { 
    // Get existing values
    var existingCountsJson = localStorage.getItem(STORAGE_KEY) || '{}';
    var existingCounts = JSON.parse(existingCountsJson);

    // Update counter
    productBreadcrumbs.find('a').each(function() {
      var collectionHandle = $(this).data('handle');

      if (collectionHandle) {
        if (existingCounts.hasOwnProperty(collectionHandle)) {
          existingCounts[collectionHandle] += 1;
        } else {
          existingCounts[collectionHandle] = 1;
        }
      }
    });

    // Update local storage
    localStorage.setItem(STORAGE_KEY, JSON.stringify(existingCounts));
  }
});


/**
 * Personalized homepage
 */
jQuery(function($) {
  if (!localStorage) return;
  if (!$('body').hasClass('template-index')) return;

  var SECTION_LIMIT = 2;

  // Get storage data
  var STORAGE_KEY = 'pxt_collection_engagement';
  var existingCountsJson = localStorage.getItem(STORAGE_KEY) || '{}';
  var existingCounts = JSON.parse(existingCountsJson);

  // Get most popular collections
  var sortable = [];
  for (var collection in existingCounts) {
      sortable.push([collection, existingCounts[collection]]);
  }
  sortable.sort(function(a, b) { return b[1] - a[1]  });

  // Find most popluar collection listing
  var visibleSectionCount = 0;

  for (var i = 0; i < sortable.length; i++) {
    var collectionData = sortable[i];
    var collectionHandle = collectionData[0];
    var section = $('.Personalized--' + collectionHandle);

    if (section.length > 0) {
      section.show();
      visibleSectionCount += 1;
      
      if (visibleSectionCount >= SECTION_LIMIT) {
        break;
      }
    }
  }

});


/**
 * Personalized collection filters
 */
// jQuery(function($) {
//   if (!localStorage) return;
//   if (!$('body').hasClass('template-collection')) return;
//   if (!$('.CollectionFilters').data('personalized')) return;

//   var STORAGE_KEY = 'pxt_filter_engagement';
//   var existingFiltersJson = localStorage.getItem(STORAGE_KEY) || '{}';
//   var existingFilters = JSON.parse(existingFiltersJson);

//   var collectionSectionEl = document.querySelector('.CollectionSection');
//   var collectionHandle = collectionSectionEl.dataset.collection;
//   var collectionUrl = JSON.parse(collectionSectionEl.dataset.sectionSettings).collectionUrl;

//   if (existingFilters[collectionHandle]) {
//     var lastUsedFilters = existingFilters[collectionHandle];
//     var filterStrings = lastUsedFilters.map(function(item) {
//       return item.replace(/-|_/g, ' ')
//     });

//     var fitlerHtml = '<div class="CollectionFilters__Recommendation">';
//     fitlerHtml += '<p class="Recommendation__Small">Still Looking For</p>';
//     fitlerHtml += '<p class="Recommendation__Large">' + filterStrings.join(' & ') + '?</p>';
//     fitlerHtml += '<a href="' + collectionUrl + '/' + lastUsedFilters.join('+') + '" class="Button Button--primary">Apply Now</a>';
//     fitlerHtml += '</div>';

//     $('.CollectionFilters').append(fitlerHtml);
//   }
// }); 


/**
 * Collection initial load
 */
jQuery(function($) {
  var $collectionSection = $('.CollectionSection');
  
  if ($collectionSection.length) {
    var settings = $collectionSection.data('section-settings');
    var colorTags = settings.currentTags.filter(function(item) {
      return item.indexOf('color_') !== -1;
    });
    
    if (colorTags.length) {
      var colorNames = colorTags.map(function(color) {
        return color.replace('colro_', '');
      });

      window.handleColorSwitchPreselect(colorNames);
    }
  }
});


/**
 * Color switch image udpates
 */
window.handleColorSwitchImages = function($productItem, colorHandle) {
  var setImage = function($image, imageData) {
    if (imageData) {
      $image.attr('src', imageData.url);
      $image.attr('alt', imageData.alt);
      $image.show();
    } else {
      $image.hide();
    }
  };

  if ($productItem.length) {
    var imageData = JSON.parse($productItem.find('.js-product-image-data').html());
    var $mainImage = $productItem.find('.js-product-images-main');
    var $hoverImage = $productItem.find('.js-product-images-hover');

    var colorImages = imageData.filter(function(image) {
      return image.color === colorHandle;
    });

    if (colorImages.length) {
      setImage($mainImage, colorImages[0])
      
      const hoverColorImage = colorImages.find(function(image) {
        return image.hover;
      });

      if (hoverColorImage) {
        setImage($hoverImage, hoverColorImage);
      } else {
        setImage($hoverImage, colorImages[1]);
      }
    } else {
      var firstImage = imageData[0];
      setImage($mainImage, firstImage)
      setImage($hoverImage);
    }
  }
};


/**
 * Color switch pre-select
 */
window.handleColorSwitchPreselect = function(selectedColors) {
  var colorMatch = JSON.parse(document.querySelector('#js-color-fitlers').innerHTML.trim());

  selectedColors.forEach(function(color) {
    var colorValue = color.replace('color_', '');
    var alternativeColors = colorMatch[colorValue];

    if (alternativeColors) {
      const alternativeColorsList = alternativeColors.split(',').map(function(item) {
        return item.trim();
      });

      var colorSwatch = document.querySelectorAll('.ProductItem__ColorSwatchList');
      Array.from(colorSwatch).forEach(function(swatch) {
        var colorInputs = swatch.querySelectorAll('.ColorSwatch__Radio');  
        var foundMatch = false;

        Array.from(colorInputs).forEach(function(input) {
          var inputColor = input.dataset.color;

          if (alternativeColorsList.indexOf(inputColor) !== -1 && !foundMatch) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { 'bubbles': true }))
            foundMatch = true;
          }
        });
      });                
    } else {
      var colorInputs = document.querySelectorAll('.ProductItem__ColorSwatchList .ColorSwatch__Radio[data-color="' + colorValue + '"]');

      Array.from(colorInputs).forEach(function(input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { 'bubbles': true }))
      });
    }
  });
};

/**
 * Initial Collection Colors
 */
jQuery(function($) {
  if ($('body').hasClass('template-collection')) {
    $('.ProductItem').each(function() {
      var $item = $(this);
      var selectedColor = $item.find('.ColorSwatch__Radio:checked').data('color-handle');
      handleColorSwitchImages($item, selectedColor);
    });
  }
});


/**
 * Announcement Slider
 */
jQuery(function($) {
  $('.AnnouncementBar__Wrapper').slick({
    autoplay: true,
  });
});


/**
 * Trask Sticky Header
 */
jQuery(function($) {
  var $header = $('#section-header');
  var headerEl = $header[0];

  $(document).on('scroll', function(e) {
    var top = headerEl.getBoundingClientRect().top;

    if (!$header.hasClass('scrolled') && top === 0) {
      $header.addClass('scrolled');
    } else if ($header.hasClass('scrolled') && top > 0) {
      $header.removeClass('scrolled');
    }
  });
});

/**
 * Custom Mobile Nav
 */
jQuery(function($) {
  var activeClass = 'active';
  var openClass = 'subnav-open';

  var $mobileNavWrap = $('.js-mobile-menu');
  var $mainLinks = $('.js-mobile-nav-main-link');
  var $backLinks = $('.js-mobile-menu-back');

  // Open Subnav
  $mainLinks.on('click', function(e) {
    var handle = $(this).data('handle');

    if (handle) {
      e.preventDefault();
      $('.js-mobile-menu-subnav.' + activeClass).removeClass(activeClass);
      $('.js-mobile-menu-subnav[data-parent="' + handle + '"]').addClass(activeClass);

      $mobileNavWrap.addClass(openClass);
    }
  });

  // Close Subnav
  $backLinks.on('click', function(e) {
    e.preventDefault();

    $('.js-mobile-menu-subnav.' + activeClass).removeClass(activeClass);
    $mobileNavWrap.removeClass(openClass);
  });
});

/**
 * Product Item Colors
 */
jQuery(function($) {
  $('.js-show-all-colors').on('click', function(e) {
    e.preventDefault();
    $(this).siblings('.ProductItem__ColorSwatchItem').show();
    $(this).remove();
  });
});


/**
 * Product mobile hierarchy
 */
jQuery(function($) {
  $('.RootCollections__Current').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('open');
  });
});


/**
 * Trask Sticky Filters
 */
jQuery(function($) {
  var $toolbar = $('.CollectionToolbar');
  if ($toolbar.length) {
    var toolbarEl = $toolbar[0];

    $(window).on('load', function() {
      var headerHeight = $('#shopify-section-header')[0].getBoundingClientRect().height;
      $toolbar.css({ top: headerHeight });

      $(document).on('scroll', function(e) {
        var top = toolbarEl.getBoundingClientRect().top;
    
        if (!$toolbar.hasClass('scrolled') && top === headerHeight) {
          $toolbar.addClass('scrolled');
        } else if ($toolbar.hasClass('scrolled') && top > headerHeight) {
          $toolbar.removeClass('scrolled');
        }
      });
    });
  }
});


/**
 * Homepage Sliders
 */
jQuery(function($) {
  $('.js-testimonial-list').slick({
    slidesToShow: 5,
    infinite: true,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '30px'
        },
      },
    ]
  }).on('setPosition', function (event, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
  });

  $('.js-instagram-list').slick({
    slidesToShow: 5,
    infinite: true,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '30px'
        },
      },
    ]
  });
});

/**
 * Division Page Sliders
 */
 jQuery(function($) {
  $('.divisions-trending__listing').slick({
    responsive: [
      {
        breakpoint: 5000,
        settings: 'unslick',
      },
      {
        breakpoint: 1007,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '30px'
        },
      },
    ]
  })
 });
